<ion-content class="ion-padding">
  <ion-item *ngIf="oneImage">
    <ion-img [src]="g.mediaUrl + oneImage.filename"></ion-img>
  </ion-item>
</ion-content>
